import { IS_BIZ_USER } from 'reactApp/appHelpers/configHelpers';
import { ROOT_FOLDER_ID } from 'reactApp/constants/magicIdentificators';
import { getAllDocumentsCategory } from 'reactApp/modules/allDocuments/allDocuments.selectors';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { setSort } from 'reactApp/modules/sort/sort.module';
import type { ESortOder, ESortTypes } from 'reactApp/modules/sort/sort.types';
import { getCurrentFolder as getCurrentFolderAction } from 'reactApp/modules/storage/storage.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { store as reduxStore } from 'reactApp/store';
import type { Sort } from 'reactApp/types/Tree';
import { sendXray } from 'reactApp/utils/ga';

import { IS_ALL_DOC_SHARED_SORT_ENABLED, IS_ALL_DOC_SORT_ENABLED } from '../featuresHelpers/features/alldocumentsSortEnabled';

export const sort = (name: string) => {
    const sortName = name.split('-');
    const sort: Sort = { type: sortName[0] as ESortTypes, order: sortName[1] as ESortOder };
    const state = reduxStore.getState();
    const folder = getCurrentFolderAction(state);
    const storage = getCurrentStorage(state);
    const id = folder?.id || ROOT_FOLDER_ID;
    const sortId = IS_BIZ_USER && storage === EStorageType.trashbin ? `${storage}${id}` : id;

    if (
        sort.type &&
        ((storage === EStorageType.alldocuments && IS_ALL_DOC_SORT_ENABLED) ||
            (storage === EStorageType.incomingPublic && IS_ALL_DOC_SHARED_SORT_ENABLED))
    ) {
        const category = getAllDocumentsCategory(state);

        const allDocumentsCategory = storage === EStorageType.alldocuments ? category : 'other';
        const xrayName = `alldocuments_sort_${folder?.id ?? 'no_folder'}_${sort.type}_${allDocumentsCategory}`;

        sendXray(xrayName);
    }

    reduxStore.dispatch(setSort({ sort, id: sortId }));
};
